import {
  Component,
  DestroyRef,
  ElementRef,
  Input,
  TemplateRef,
  inject,
} from '@angular/core';
import { MaterialModule } from '@fullyops/shared/material.module';
import { I18NextCapPipe, I18NextModule } from 'angular-i18next';
/** PRIMARY is the page toolbar; SECONDARY is a shorter bar, e.g. for actions under a tab bar. */
export type ToolbarRolePreset = 'PRIMARY' | 'SECONDARY';

/**
 * The toolbar sticks to the top of the page, so its height is published to the page as
 * `--fo-toolbar-height`, for what sticks or scrolls into view below it.
 */
@Component({
  selector: 'fo-toolbar',
  imports: [MaterialModule, I18NextModule],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
  host: { '[class.secondary]': "rolePreset === 'SECONDARY'" },
})
export class ToolbarComponent {
  @Input() title: string;
  @Input() rolePreset: ToolbarRolePreset = 'PRIMARY';

  constructor() {
    const host = inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
    const resize = new ResizeObserver(([entry]) =>
      host.parentElement?.style.setProperty(
        '--fo-toolbar-height',
        `${entry.borderBoxSize[0].blockSize}px`,
      ),
    );
    resize.observe(host);
    inject(DestroyRef).onDestroy(() => {
      resize.disconnect();
      host.parentElement?.style.removeProperty('--fo-toolbar-height');
    });
  }
}
